import type { SupportContact, SupportContactType } from '@/lib/apollo/query/get-applicant'

const supportedContactTypes: SupportContactType[] = ['Webform', 'Email', 'NRLA Webform']

const enabledSupportContactsFilter = ({ contactType, status }: SupportContact) =>
  supportedContactTypes.includes(contactType) && status !== 'Closed'

export const getOldestContact = (supportContacts: SupportContact[]) => {
  return supportContacts?.filter(enabledSupportContactsFilter).reduce((prev, current) => {
    return new Date(current.createdAt) < new Date(prev.createdAt) ? current : prev
  })
}

export const hasActiveSupportContacts = (contacts?: SupportContact[]): boolean => {
  if (!contacts) {
    return false
  }

  return contacts.some(enabledSupportContactsFilter)
}
